// Curated fallback images per category, used when a live article image fails to load.
const W = '?w=900&q=80&auto=format&fit=crop';

export const FALLBACK = {
  headlines: [
    'https://images.unsplash.com/photo-1643507246388-f58d54b2254f',
    'https://images.unsplash.com/photo-1652700841019-69605b0211d3',
    'https://images.unsplash.com/photo-1568267938179-f50e67de5ffc',
    'https://images.unsplash.com/photo-1696943444991-def9485f89f8',
  ],
  politics: [
    'https://images.unsplash.com/photo-1637768316226-44d97e7d6af4',
    'https://images.unsplash.com/photo-1573181759662-1c146525b21f',
    'https://images.unsplash.com/photo-1594581979864-36977b15d0dc',
    'https://images.unsplash.com/photo-1540908390241-82158ab62887',
  ],
  sport: [
    'https://images.unsplash.com/photo-1557174949-3b1f5b2e8fac',
    'https://images.unsplash.com/photo-1537882111161-c3379a777c8b',
    'https://images.unsplash.com/photo-1581852549708-72910bd52cff',
    'https://images.unsplash.com/photo-1580748141549-71748dbe0bdc',
  ],
  financials: [
    'https://images.unsplash.com/photo-1594655151525-cc979fc9bf8b',
    'https://images.unsplash.com/photo-1613871758600-fb390c5d3fbb',
    'https://images.unsplash.com/photo-1758830596893-7aa7c7caf245',
    'https://images.unsplash.com/photo-1699884745550-07d309f2f61d',
  ],
  fashion: [
    'https://images.unsplash.com/photo-1554881070-74595ca2b74c',
    'https://images.unsplash.com/photo-1532332248682-206cc786359f',
    'https://images.unsplash.com/photo-1441984904996-e0b6ba687e04',
    'https://images.unsplash.com/photo-1555529771-835f59fc5efe',
  ],
};

// Stable pick based on the article id so a card always shows the same fallback.
export function fallbackImage(category, id = '') {
  const list = FALLBACK[category] || FALLBACK.headlines;
  let sum = 0;
  for (let i = 0; i < id.length; i++) sum = (sum + id.charCodeAt(i)) % 997;
  return list[sum % list.length] + W;
}
